import { useAtomValue } from "jotai";
import { userAtom } from "../utils/store";

export const useApplicationPeriod = () => {
  const user = useAtomValue(userAtom);

  const shouldPayLateApplicationFee =
    user?.amount === user?.lateApplicationAmount;
  const lateApplicationFee =
    (user?.lateApplicationAmount ?? 0) - (user?.earlyApplicationAmount ?? 0);

  const hasLateApplicationPeriod =
    !!user?.lateApplicationStartDate && !!user?.lateApplicationEndDate;

  const isApplicationPeriodActive = () => {
    const currentDate = new Date();
    const applicationStartDate = user?.applicationStartDate
      ? new Date(user.applicationStartDate)
      : null;
    const applicationEndDate = user?.applicationEndDate
      ? new Date(user.applicationEndDate)
      : null;
    const lateApplicationEndDate = hasLateApplicationPeriod
      ? new Date(user.lateApplicationEndDate as string)
      : null;

    const periodEndDate = lateApplicationEndDate ?? applicationEndDate;

    if (!applicationStartDate || !periodEndDate) {
      return false;
    }

    return currentDate >= applicationStartDate && currentDate <= periodEndDate;
  };

  const isLateApplicationPeriod = () => {
    if (!hasLateApplicationPeriod) {
      return false;
    }

    const currentDate = new Date();
    const lateApplicationStartDate = new Date(
      user?.lateApplicationStartDate || "",
    );
    const lateApplicationEndDate = new Date(user?.lateApplicationEndDate || "");
    return (
      currentDate >= lateApplicationStartDate &&
      currentDate <= lateApplicationEndDate
    );
  };
  return {
    isApplicationPeriodActive,
    isLateApplicationPeriod,
    shouldPayLateApplicationFee,
    lateApplicationFee,
  };
};
